import { takeLatest, put, call, select } from 'redux-saga/effects';
import { GET_BOOKING_USERS_SAGA } from "../sagaTypes";
import { loaderAction, setBookingUsersFormAction } from "../rootReducer";
import { url } from "../../config";
import growl from "../../lib/growl/growl";
import { setLocalStorage } from "../../helpers/LocalStorage";

const request = data => {
    return fetch(`${ url }/get_u_booking`, {
        method: 'post',
        body: data
    })
        .then(response => response.json()).catch(error => console.log(error))
};

function* workerGetBookingUsers(args) {
    const user = yield select(state => state.user);
    const bookingForm = yield select(state => state.bookingForm);

    yield put(loaderAction(true));
    try {
        let formData = new FormData();
        formData.append('user_id', user.id);
        formData.append('hash', user.hash);

        formData.append('booking_id', args.data.booking_id);

        const response = yield call (request, formData);

        // Если не прошли проверку хеша разлогиниваемся
        if (response.void) {
            setLocalStorage('afp_fitness', '').then(() => window.location.reload());
        }

        if (response.success) {
            yield put(setBookingUsersFormAction({
                open: true,
                id: args.data.booking_id,
                users: [],
                userInput: '',
                checkedUsers: response.users,
                canceled: args.data.canceled,
                datetime: response.booking_datetime,
                date: response.date,
                time: response.time,
                type: response.type,
                coach: response.coach
            }));
        }
        else if (response.error) {
            growl({ type: 'error', message: response.message });
        }
    }
    catch(error) {
        console.log(error);
        yield put(loaderAction(false));
    }
    finally {
        yield put(loaderAction(false));
    }
}

export default function* watcherGetBookingUsers() {
    yield takeLatest(GET_BOOKING_USERS_SAGA, workerGetBookingUsers);
}